import React, { FC } from "react"
import styled from "styled-components"
import { BrandColor, BrandShadow, theme } from "../../util/styles/theme"

export const boxSizes = ["small", "medium"] as const

export type BoxSize = typeof boxSizes[number]

export interface BoxProps {
  backgroundColor?: BrandColor
  bottomMargin?: boolean
  className?: string
  padding?: boolean
  shadow?: BrandShadow
  size?: BoxSize
}

const Container = styled.div<BoxProps>`
  ${({ shadow }) => shadow && theme.shadows[shadow]};
  background-color: ${({ backgroundColor }) => theme.colors[backgroundColor]};
  border-radius: ${({ size }) => theme.borderRadius[size]};
  padding: ${({ size, padding }) => padding && theme.borderRadius[size]};
  margin-bottom: ${({ size, bottomMargin }) =>
    bottomMargin && theme.spacings[size]};
`

export const Box: FC<BoxProps> = ({ children, ...rest }) => (
  <Container {...rest}>{children}</Container>
)

Box.defaultProps = {
  backgroundColor: "white",
  bottomMargin: false,
  padding: true,
  shadow: "flat",
  size: "medium",
}
